import styled from '@emotion/styled'
import { Tabs } from '@mui/material'
import { StyledTabProps, FullWidthBackgroundProps } from './types'
import { breakpoints } from '@utils/breakpoints'

export const PageHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  width: 100vw;
  margin-left: -50vw;
  left: 50%;
  position: relative;
  padding: 0 45px;

  @media (max-width: 900px) {
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding: 0;
    position: absolute;
    left: 0;
    right: 0;
    width: 100vw;
    margin-left: 0;
    z-index: 1;
  }
`

export const TabsStyled = styled(Tabs)`
  margin-top: 0px;
  flex-shrink: 0;

  & .MuiTab-textColorPrimary {
    color: #757575;
    padding: 25px;
    font-size: 16px;
    text-transform: capitalize;
    min-width: auto;
  }

  & .MuiTabs-indicator {
    border-bottom: 5px solid #000000;
  }

  & .Mui-selected {
    color: #000000 !important;
    font-weight: 600;
  }

  & .MuiTabs-scroller {
    overflow: visible !important;
  }

  & .MuiTabs-flexContainer {
    flex-wrap: nowrap;
  }

  @media (max-width: 900px) {
    margin-top: 10px;

    & .MuiTab-textColorPrimary {
      padding: 15px 20px;
      font-size: 14px;
      white-space: nowrap;
    }
  }
`

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

export const FullWidthBackground = styled.div<FullWidthBackgroundProps>`
  width: 300vw;
  margin-left: calc(
    -50vw + ${({ marginPercentOffset }) => marginPercentOffset || '50%'}
  );
  background-color: ${({ backgroundColor }) => backgroundColor || '#F3F3F3'};
  position: absolute;
  height: 100vh;
  top: 0;
  left: 0;

  @media ${breakpoints.xl} {
    margin-left: calc(
      -49vw + ${({ marginPercentOffset }) => marginPercentOffset || '50%'}
    );
  }
`

export const TabPanelContainer = styled.div`
  width: 100%;
  margin: 0 0px 300px 0px;
  background-color: #f3f3f3;

  @media (max-width: 900px) {
    margin: 0 0px 200px 0px;
  }
`

export const TabContentContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  overflow-y: auto;
  background-color: #f3f3f3;

  &.subscriptions-tabs {
    height: unset;
  }

  @media (max-width: 900px) {
    padding-top: 60px;
  }

  @media ${breakpoints.md} {
    left: 0;
  }

  @media ${breakpoints.xl} {
    left: -25px;
  }

  @media ${breakpoints.xl} {
    left: 0;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`
